import type { Channel } from "@sobidogam/platform-ports";
import { useState } from "react";
import { navigate } from "./chrome";
import { InstallGuide } from "./InstallPrompt";
export function RecordingRoutes({ channel }: { channel: Channel }) {
	const [install, setInstall] = useState(false);
	return (
		<section className="recording-routes">
			<h1>결제 직후 한 건 남기는 길</h1>
			<ol>
				<li>결제 알림을 복사해요.</li>
				<li>소비도감에서 결제 알림 붙여 넣기를 눌러요.</li>
				<li>매장·금액·날짜를 확인하고 저장해요.</li>
			</ol>
			<button
				className="button"
				type="button"
				onClick={() => navigate("/app/capture")}
			>
				붙여 넣기 칸 열기
			</button>
			<h2>안드로이드 문자 공유</h2>
			<p>
				문자 앱에서 결제 문자를 길게 누르고 공유 → 소비도감을 골라요. 공유
				목록은 문자 앱마다 달라요.
			</p>
			{channel !== "ait" ? (
				<>
					<button
						className="quiet-button"
						type="button"
						onClick={() => setInstall(true)}
					>
						홈 화면에 추가
					</button>
					<h2>아이폰 단축어</h2>
					<ol>
						<li>단축어 앱에서 ‘클립보드 가져오기’를 넣어요.</li>
						<li>URL 인코딩 → URL 열기를 넣어요.</li>
						<li>
							주소를 <code>https://sobidogam.com/app/capture#paste=</code>와
							인코딩한 텍스트로 이어요.
						</li>
					</ol>
					<p className="field-hint">
						자동화·Apple Pay 트리거와 카드 지원 범위는 기기에서 확인해 주세요.
						복사 없이 모든 알림을 자동으로 읽는 기능은 없어요.
					</p>
				</>
			) : (
				<p>토스에서는 결제 알림을 복사한 뒤 붙여 넣기 버튼을 눌러요.</p>
			)}
			<h2>이 기기 밖으로 나가는 것</h2>
			<table>
				<thead>
					<tr>
						<th>내용</th>
						<th>어디에 남나요?</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>알림 원문</td>
						<td>이 기기에서 읽은 뒤 저장하지 않아요.</td>
					</tr>
					<tr>
						<td>기록·집 안 물건·마감</td>
						<td>이 기기 안에 저장해요.</td>
					</tr>
					<tr>
						<td>카드 그림</td>
						<td>직접 공유할 때 고른 앱으로 보내요.</td>
					</tr>
					<tr>
						<td>사용 통계</td>
						<td>허용한 이벤트와 구간값만 보내요. 설정에서 끌 수 있어요.</td>
					</tr>
					<tr>
						<td>사진 AI·서버 백업</td>
						<td>현재 꺼져 있어요. 암호화 파일로 백업해요.</td>
					</tr>
				</tbody>
			</table>
			{install ? (
				<InstallGuide
					onClose={() => setInstall(false)}
					onOutcome={() => undefined}
				/>
			) : null}
		</section>
	);
}
